import { CHAT_MARKER_TAG_NAMES } from "../markdown/chatMarkers"
import { stripOuterMarkdownFence } from "./stripOuterMarkdownFence"

const CHAT_MARKER_TAG_PATTERN = new RegExp(`</?(?:${CHAT_MARKER_TAG_NAMES})\\b[^>]*>`, "gi")

const ARTIFACT_DOWNLOAD_LINE_PATTERN = /File created successfully! Download URL:\s*(https?:\/\/[^\s\n]+)[ \t]*\n?/

const BLANK_LINE_RUN_PATTERN = /\n{3,}/g

export interface ArtifactDownloadLine {
  url: string
  filename: string
}

export function artifactDownloadLineOf(content: string): ArtifactDownloadLine | null {
  const match = ARTIFACT_DOWNLOAD_LINE_PATTERN.exec(content)
  if (!match) return null
  const url = match[1]
  const lastSlash = url.lastIndexOf("/")
  const filename = lastSlash >= 0 && lastSlash < url.length - 1 ? url.slice(lastSlash + 1) : "download"
  return { url, filename }
}

export function withoutArtifactDownloadLine(content: string): string {
  return content.replace(new RegExp(ARTIFACT_DOWNLOAD_LINE_PATTERN.source, "g"), "")
}

export function stripChatWidgetMarkers(content: string): string {
  return withoutArtifactDownloadLine(content.replace(CHAT_MARKER_TAG_PATTERN, ""))
}

export function chatResponseCopyText(content: string): string {
  return stripOuterMarkdownFence(stripChatWidgetMarkers(content))
    .replace(BLANK_LINE_RUN_PATTERN, "\n\n")
    .trim()
}
